import { useSyncExternalStore } from "react";

// "Fav Toggles" access button: while on, a normal tap pins a toggle option (same as Shift+click).
let on = false;
const subs = new Set();
// Every click acts like Shift+click while on (the existing favourite/pin feature), except the toggle itself.
const asShift = (e) => { if (!e.target?.closest?.("[data-fav-toggles]")) { try { Object.defineProperty(e, "shiftKey", { get: () => true }); } catch { /* noop */ } } };
export const setPinMode = (v) => {
    on = !!v;
    if (on) window.addEventListener("click", asShift, true); else window.removeEventListener("click", asShift, true);
    subs.forEach((f) => f());
};
export const getPinMode = () => on;
export const usePinMode = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => on);
